import styled from 'styled-components';
import { Link as LinkS} from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';

const baseButton = `
  border-radius: 4px;
  white-space: nowrap;
  padding: 12px 36px;
  font-size: 13px;
  font-family: var(--font-body);
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  outline: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all 0.25s ease-in-out;
  text-decoration: none;
  border: 2px solid transparent;
`;

export const Button = styled(LinkR)`
  ${baseButton}
  background: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  color: var(--color-off-white);
  border-color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  box-shadow: var(--shadow-sm);

  &:hover {
    background: transparent;
    color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
    box-shadow: var(--shadow-md);
  }
`;

export const ExternalButton = styled.a`
  ${baseButton}
  background: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  color: var(--color-off-white);
  border-color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  box-shadow: var(--shadow-sm);

  &:hover {
    background: transparent;
    color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
    box-shadow: var(--shadow-md);
  }
`;

export const RouteButton = styled(LinkR)`
  ${baseButton}
  background: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  color: var(--color-off-white);
  border-color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  box-shadow: var(--shadow-sm);

  &:hover {
    background: transparent;
    color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
    box-shadow: var(--shadow-md);
  }
`;

export const ScrollButton = styled(LinkS)`
  ${baseButton}
  background: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  color: var(--color-off-white);
  border-color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
  box-shadow: var(--shadow-sm);

  &:hover {
    background: transparent;
    color: ${({ primary }) => (primary ? 'var(--color-gold)' : 'var(--color-forest)')};
    box-shadow: var(--shadow-md);
  }
`;